import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["step"]
  static classes = ["hidden"]
  static values = { index: { type: Number, default: 0 } }

  next() {
    this.indexValue = Math.min(this.indexValue + 1, this.stepTargets.length - 1)
  }

  previous() {
    this.indexValue = Math.max(this.indexValue - 1, 0)
  }

  indexValueChanged() {
    this.stepTargets.forEach((step, index) => {
      step.classList.toggle(this.hiddenClass, index !== this.indexValue)
    })
  }
}
